var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, RootPath, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixDevcenterBiEventsV1SendBiEventResponse from '@wix/ambassador-devcenter-bi-events-v1-send-bi-event-response/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var EventName;
(function (EventName) {
    EventName["UNKNOWN"] = "UNKNOWN";
    EventName["APP_DASHBOARD_LOADED"] = "APP_DASHBOARD_LOADED";
    EventName["APP_FINISHED_CONFIGURATION"] = "APP_FINISHED_CONFIGURATION";
    EventName["APP_UPGRADED"] = "APP_UPGRADED";
    EventName["PRIMARY_ACTION_PERFORMED"] = "PRIMARY_ACTION_PERFORMED";
    EventName["CUSTOM"] = "CUSTOM";
    EventName["CHARGE"] = "CHARGE";
    EventName["FUNDS_RETURNED"] = "FUNDS_RETURNED";
    EventName["APP_FINISH_BUSINESS_SETUP"] = "APP_FINISH_BUSINESS_SETUP";
    EventName["APP_DEPLOYED"] = "APP_DEPLOYED";
    EventName["APP_SETUP_FINISHED"] = "APP_SETUP_FINISHED";
})(EventName || (EventName = {}));
const _sendBIEventRequest = {};
const _sendBIEventResponse = {};
/**
 * Submit a BI event to Wix.
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function sendBiEvent(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventName: '$[0].eventName',
            customEventName: '$[0].customEventName',
            eventData: '$[0].eventData',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _sendBIEventRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _sendBIEventResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [RootPath],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixDevcenterBiEventsV1SendBiEventResponse.sendBiEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=devcenter-bi-events-v1-send-bi-event-response.universal.js.map